import type { FC } from "react";
import Avatar from "@mui/material/Avatar";
import { SparklesIcon } from "./SparklesIcon";

interface AssistantAvatarProps {
  /** Аватар, загруженный площадкой; null: знак «Искры» в цвете бренда. */
  avatarUrl: string | null;
  size: number;
  alt?: string;
}

export const AssistantAvatar: FC<AssistantAvatarProps> = ({
  avatarUrl,
  size,
  alt = "",
}) =>
  avatarUrl ? (
    <Avatar src={avatarUrl} alt={alt} sx={{ width: size, height: size }} />
  ) : (
    <Avatar
      aria-label={alt || undefined}
      sx={{
        width: size,
        height: size,
        bgcolor: "primary.main",
        color: "primary.contrastText",
      }}
    >
      <SparklesIcon size={Math.round(size * 0.55)} />
    </Avatar>
  );
